<h2 mat-dialog-title>Record Details</h2>

<mat-dialog-content class="content">

  <div class="detail-row">
    <span class="label">Action:</span>
    <span class="value">{{ data.Action }}</span>
  </div>

  <div class="detail-row">
    <span class="label">Application:</span>
    <span class="value">{{ data.App }}</span>
  </div>

  <div class="detail-row">
    <span class="label">Channel:</span>
    <span class="value">{{ data.Channel }}</span>
  </div>

  <div class="detail-row">
    <span class="label">Value:</span>
    <span class="value">{{ data.Value }}</span>
  </div>

  <div class="detail-row">
    <span class="label">Description:</span>
    <span class="value">{{ data.Description }}</span>
  </div>

  <div class="detail-row">
    <span class="label">Customer:</span>
    <span class="value">{{ data.ByCustomer ? 'Yes' : 'No' }}</span>
  </div>

  <div class="detail-row">
    <span class="label">Section:</span>
    <span class="value">{{ data.Section }}</span>
  </div>

  <div class="detail-row">
    <span class="label">Date:</span>
    <span class="value">{{ data.DateTime | date:'dd/MM/yyyy HH:mm:ss' }}</span>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
